import isoCountries from "i18n-iso-countries";
import { enabledIssuerPageBoxes } from "lib/users/settings/enabledIssuerPageBoxes";
import { financialsTable } from "lib/users/settings/financialsTable";
import { screener } from "lib/users/settings/screener";
import { z } from "zod";

export const UserSettingsSchema = z.object({
  theme: z.enum(["DARK", "LIGHT"]).default("LIGHT"),
  country: z
    .string()
    .refine(
      (countryCode) => isoCountries.isValid(countryCode),
      (countryCode) => ({ message: `Invalid country code: ${countryCode}` }),
    )
    .optional()
    .nullable(),
  language: z.union([z.literal("en-US"), z.literal("pt-BR")]).default("pt-BR"),
  financialsTable,
  enabledIssuerPageBoxes,
  screener,
  hasClosedMarch24PerpetualBlackPopUp: z
    .boolean()
    .default(false)
    .describe("Determines if the User has closed the one-off March '24 Black popup"),
});

export type UserSettingsShape = z.infer<typeof UserSettingsSchema>;
export type UserSettingsOptionsKeys = keyof UserSettingsShape;
export type UserSettingsOptionsPaths = Paths<UserSettingsShape>;

// Took this stuff from: https://stackoverflow.com/a/58436959
type Paths<T> = T extends object
  ? { [K in keyof T]: `${Exclude<K, symbol>}${"" | `.${Paths<T[K]>}`}` }[keyof T]
  : never;
